export default __webpack_public_path__ + "static/media/card-image-2.32ed88e2.png";